var _rect, _rect2, _rect3, _path, _g, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 48,
    viewBox: "0 0 608 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 1,
    transform: "matrix(-1 0 0 1 241 23.5)",
    fill: "url(#paint0_linear_2255_15393)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    width: 126,
    height: 48,
    rx: 24,
    fill: "white",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 241.5,
    y: 0.5,
    width: 125,
    height: 47,
    rx: 23.5,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.875 20.3864L284.795 22.7273H269.852L270.705 20.3864H285.875ZM283.841 25L282.739 27.3636H269.852L270.705 25H283.841ZM288.648 14.2159L287.307 17.0909C286.883 16.7273 286.42 16.3977 285.92 16.1023C285.42 15.8068 284.883 15.572 284.307 15.3977C283.731 15.2159 283.114 15.125 282.455 15.125C281.242 15.125 280.163 15.4508 279.216 16.1023C278.269 16.7538 277.523 17.7311 276.977 19.0341C276.439 20.3295 276.17 21.9432 276.17 23.875C276.17 25.8068 276.439 27.4205 276.977 28.7159C277.523 30.0114 278.269 30.9848 279.216 31.6364C280.163 32.2803 281.242 32.6023 282.455 32.6023C283.121 32.6023 283.742 32.5152 284.318 32.3409C284.902 32.1667 285.432 31.9394 285.909 31.6591C286.394 31.3712 286.83 31.0682 287.216 30.75L288.591 33.6136C287.788 34.3409 286.856 34.8902 285.795 35.2614C284.735 35.6326 283.621 35.8182 282.455 35.8182C280.553 35.8182 278.867 35.3371 277.398 34.375C275.936 33.4129 274.788 32.0417 273.955 30.2614C273.121 28.4735 272.705 26.3447 272.705 23.875C272.705 21.3977 273.121 19.2652 273.955 17.4773C274.788 15.6894 275.936 14.3144 277.398 13.3523C278.867 12.3902 280.553 11.9091 282.455 11.9091C283.667 11.9091 284.795 12.1098 285.841 12.5114C286.886 12.9053 287.822 13.4735 288.648 14.2159Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.707 15.2929C332.317 14.9024 331.683 14.9024 331.293 15.2929L327.293 19.2929C326.902 19.6834 326.902 20.3166 327.293 20.7071C327.683 21.0976 328.317 21.0976 328.707 20.7071L331 18.4142L331 32C331 32.5523 331.448 33 332 33C332.552 33 333 32.5523 333 32V18.4142L335.293 20.7071C335.683 21.0976 336.317 21.0976 336.707 20.7071C337.098 20.3166 337.098 19.6834 336.707 19.2929L332.707 15.2929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 16C323 15.4477 322.552 15 322 15C321.448 15 321 15.4477 321 16V29.5858L318.707 27.2929C318.317 26.9024 317.683 26.9024 317.293 27.2929C316.902 27.6834 316.902 28.3166 317.293 28.7071L321.293 32.7071C321.683 33.0976 322.317 33.0976 322.707 32.7071L326.707 28.7071C327.098 28.3166 327.098 27.6834 326.707 27.2929C326.317 26.9024 325.683 26.9024 325.293 27.2929L323 29.5858V16Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 23.5,
    width: 240,
    height: 1,
    fill: "url(#paint1_linear_2255_15393)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2255_15393",
    x1: 1.11628,
    y1: 1.5001,
    x2: 240,
    y2: 1.50032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2255_15393",
    x1: 368.116,
    y1: 25.0001,
    x2: 607,
    y2: 25.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroLine);
export default __webpack_public_path__ + "static/media/euro-line.ebba958f8729ab38af5f9ea6c7b3d89b.svg";
export { ForwardRef as ReactComponent };